import { v4 as uuid } from 'uuid';

import { config } from 'src/config';
import { navigationService } from 'src/services/navigation-service';
import { initializeAuthorization } from 'src/state/auth/auth-slice';
import { AppDispatch } from 'src/state/types';
import { PkceUtils } from 'src/utils/pkce-utils';

export const startAuthenticationActionCreator = () => (dispatch: AppDispatch) => {
  const authorizationUrl = config.AUTH_URL;
  const scope = config.AUTH_SCOPES;
  const clientId = config.AUTH_CLIENT_ID;
  const redirectUri = navigationService.getRedirectUri();
  const appLanguage = config.LANGUAGE;
  const authTheme = config.AUTH_THEME;
  const url = new URL(authorizationUrl);
  const params = url.searchParams;
  const authenticationKey = uuid();
  const { codeChallenge, codeVerifier } = PkceUtils.generateChallengeAndCodeVerifier();

  params.append('client_id', clientId);
  params.append('redirect_uri', redirectUri);
  params.append('response_type', 'code');
  params.append('scope', `openid ${scope}`);
  params.append('state', authenticationKey);
  params.append('code_challenge_method', 'S256');
  params.append('code_challenge', codeChallenge);
  params.append('locale', appLanguage);
  params.append('theme', authTheme);

  dispatch(initializeAuthorization({ authenticationKey, codeVerifier }));

  window.location.assign(url.toString());
};
